import * as React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import Lottie from 'lottie-react';
import { font } from '../../style/text';
import color from '../../style/color';

const loadingAnimation = require('../../assets/lottie/loading-circle-green.json');

export const TEXT_TRANSITION_DELAY_IN_MS = 3000;

export function useIsFrench(): boolean {
    return (navigator.language || '').toLowerCase().startsWith('fr');
}

export function useCyclingText(texts: string[]): string {
    const [index, setIndex] = React.useState(0);
    React.useEffect(() => {
        if (texts.length <= 1) return;
        let currentIndex = 0;
        const interval = setInterval(() => {
            currentIndex = Math.min(currentIndex + 1, texts.length - 1);
            setIndex(currentIndex);
        }, TEXT_TRANSITION_DELAY_IN_MS);
        return () => clearInterval(interval);
    }, [texts]);
    return texts[index] ?? texts[0];
}

export function LottieWithText({ text }: { text: string }) {
    return (
        <View style={styles.lottieWithTextContainer}>
            <View style={styles.lottieContainer}>
                <Lottie
                    style={{ width: 140, height: 140 }}
                    animationData={loadingAnimation}
                    loop={true}
                />
            </View>
            <Text style={styles.lottieText}>{text}</Text>
        </View>
    );
}

export function getPrePaymentTexts(isFrench: boolean, numberOfCards: number): string[] {
    if (isFrench)
        return [
            numberOfCards > 1 ? 'Vérification de vos bons...' : 'Vérification de votre bon...',
            'Préparation de votre panier...',
            'Plus que quelques instants...',
        ];
    return [
        numberOfCards > 1 ? 'Checking your gift cards...' : 'Checking your gift card...',
        'Preparing your cart...',
        'Just a few minutes more...',
    ];
}

export function getPostPaymentTexts(isFrench: boolean, numberOfCards: number): string[] {
    if (isFrench)
        return [
            'Réception de votre paiement...',
            numberOfCards > 1 ? 'Récupération de vos bons...' : 'Récupération de votre bon...',
            'Plus que quelques instants...',
        ];
    return [
        'Processing your payment...',
        numberOfCards > 1 ? 'Creating your cards...' : 'Creating your card...',
        'Finalizing your purchase...',
    ];
}

const styles = StyleSheet.create({
    lottieWithTextContainer: {
        alignItems: 'center',
        flex: 1,
        justifyContent: 'center',
        paddingVertical: 60,
    },
    lottieContainer: {
        marginBottom: 20,
    },
    lottieText: {
        fontFamily: font.ambitBold,
        fontSize: 18,
        lineHeight: 26,
        textAlign: 'center',
        color: color.black,
        width: 330,
    },
});
